module.exports = "<p>recent works</p>\n"


//////////////////
// WEBPACK FOOTER
// ./~/@c4/programming/src/app/common/recent/recent.component.html
// module id = 1538
// module chunks = 2